import { SelectionChangedEvent } from "ag-grid-community";
import { CounterCustomerChargeEntity } from "domain/entity/CounterCustomerCharge/CounterCustomerChargeEntity";
import { EMPTY_COUNTER_CUSTOMER_CHARGE_SEARCH_CRITERIA } from "domain/entity/CounterCustomerCharge/CounterCustomerChargeSearchCriteria";
import _ from "lodash";
import { INITIAL_ADDITIONAL_CHARGE_COL_DEF, INITIAL_ADDITIONAL_CHARGE_COL_DEF_AQCT, INITIAL_ADDITIONAL_CHARGE_COL_DEF_OICT, transferRowData } from "presentation/constant/CounterCustomerCharge/AdditionalChargeColumnDefinition";
import { MessageConstant } from "presentation/constant/MessageConstant";
import { WorkspaceConstant } from "presentation/constant/WorkSpaceConstant";
import { useCounterCustomerChargeMaintenanceVM } from "presentation/hook/CounterCustomerCharge/useCounterCustomerChargeMaintenanceVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useCounterCustomerChargeMaintenanceTracked } from "presentation/store/CounterCustomerCharge/CounterCustomerChargeMaintenanceProvider";
import { ConfirmDeleteModal } from "presentation/view/components/ConfirmDeleteModal";
import NbisTable from "presentation/view/components/TableWrapper/NbisTable";
import { TableWrapper } from "presentation/view/components/TableWrapper/TableWrapper";
import { memo, useCallback, useMemo, useRef, useState } from "react";
import { HPHButton, Loader, SliderPanel } from "veronica-ui-component/dist/component/core";
import { StyledAction } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";
import AdditionalChargeEditPanel from "./AdditionalChargeEditPanel";


const AdditionalChargeTablePanel: React.FC = () => {
    const [counterCustomerChargeState] = useCounterCustomerChargeMaintenanceTracked();
    const counterCustomerChargeVM = useCounterCustomerChargeMaintenanceVM();
    const { additionalState } = counterCustomerChargeState;
    const gridRef: any = useRef(null);
    const messageBarVM = useMessageBarVM();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [anaInfoState] = useANAInfoTracked();
    const { operatingUnit } = anaInfoState;

    const handleSelectionChange = useCallback((e: SelectionChangedEvent) => {
        const selectedRows = e.api.getSelectedRows();
        counterCustomerChargeVM.updateAdditionalSelectedRows(selectedRows);
    }, [counterCustomerChargeVM])

    const handleAdd = useCallback(() => {
        counterCustomerChargeVM.onAdditionalAdd();
    }, [counterCustomerChargeVM]);

    const handEdit = useCallback(() => {
        if (_.isEmpty(additionalState.selectedRows) && additionalState.selectedRows?.length !== 1) {
            messageBarVM.showError('Please select a record.');
            return;
        }
        counterCustomerChargeVM.onAdditionalEdit(additionalState.selectedRows[0]);
    }, [counterCustomerChargeVM, messageBarVM, additionalState.selectedRows]);

    const handleRowDoubleClick = useCallback((entity: CounterCustomerChargeEntity) => {
        counterCustomerChargeVM.onAdditionalEdit(entity);
    }, [counterCustomerChargeVM]);

    const handleDeleteClick = useCallback(() => {
        if (_.isEmpty(additionalState.selectedRows)) {
            messageBarVM.showError('Please select a record.');
            return;
        }

        counterCustomerChargeVM.onDeleteClick();
        /*setIsLoading(true);
        const ids = additionalState.selectedRows.map(x => x.id);
        let searchCriteria = {
            ...EMPTY_COUNTER_CUSTOMER_CHARGE_SEARCH_CRITERIA,
        };
        searchCriteria = {
            ...searchCriteria,
            billOfLadingNo: additionalState.selectedRows[0].billOfLading,
            shippingBill: additionalState.selectedRows[0].shippingBill
        }
        counterCustomerChargeVM.onDeleteAdditional(ids).then(res => {
            if (res && res.success) {
                counterCustomerChargeVM.searchAdditionalByCriteria(searchCriteria);
                // counterCustomerChargeVM.onSearchAdditional(ids);
                setIsLoading(false);
                messageBarVM.showSuccess('Delete Successfully.');
            } else {
                setIsLoading(false);
                messageBarVM.showError('Delete Failed.');
            }
        }).catch(() => {
            setIsLoading(false);
            messageBarVM.showError('Delete Failed.');
        });*/
    }, [additionalState.selectedRows, counterCustomerChargeVM, messageBarVM]);

    const handleCancel = useCallback(() => {
        counterCustomerChargeVM.onCancelDelete();
    }, [counterCustomerChargeVM])

    const handleDelete = useCallback(() => {
        setIsLoading(true);

        const ids = additionalState.selectedRows.map(x => x.id);
        counterCustomerChargeVM.onDeleteAdditional(ids).then(res => {
            if (res && res.success) {
                //counterCustomerChargeVM.searchAdditionalByCriteria(searchCriteria);
                // counterCustomerChargeVM.onSearchAdditional(ids);
                setIsLoading(false);
                messageBarVM.showSuccess('Delete Successfully.');
            } else {
                setIsLoading(false);
                messageBarVM.showError('Delete Failed.');
            }
        }).catch(() => {
            setIsLoading(false);
            messageBarVM.showError('Delete Failed.');
        });
    }, [additionalState.selectedRows, counterCustomerChargeVM, messageBarVM])

    const handApply = useCallback(() => {
        setIsLoading(true);
        //const ids = additionalState.tableData?.map(x => x.id);
        if (!(additionalState.tableData && additionalState.tableData.length > 0)) {
            setIsLoading(false);
            messageBarVM.showError("No details under this header, Please input 1 detail at least. ");
            return;
        }
        let searchCriteria = {
            ...EMPTY_COUNTER_CUSTOMER_CHARGE_SEARCH_CRITERIA,
        };
        searchCriteria = {
            ...searchCriteria,
            billOfLadingNo: additionalState.tableData[0]?.billOfLading,
            shippingBill: additionalState.tableData[0]?.shippingBill
        }
        const tempTableDatas = counterCustomerChargeVM.copyAdditionalHdrInfo(additionalState.tableData, additionalState.editingEntity);
        counterCustomerChargeVM.onApplyAdditional(tempTableDatas).then(async (data) => {
            if (data && data.success) {
                //await counterCustomerChargeVM.onSearchAdditional(ids);
                setIsLoading(false);
                if (data.msg && data.msg !== 'OK') {

                    messageBarVM.showError(data.msg);
                    await counterCustomerChargeVM.searchAdditionalByCriteria(searchCriteria);
                    // await counterCustomerChargeVM.onSearchAdditional(ids);
                } else {
                    messageBarVM.showSuccess("Apply Successfully.");
                    counterCustomerChargeVM.onAdditionalClose();
                    await counterCustomerChargeVM.onSearch(counterCustomerChargeState.searchCriteria, operatingUnit);
                }
            } else {
                await counterCustomerChargeVM.searchAdditionalByCriteria(searchCriteria);
                // await counterCustomerChargeVM.onSearchAdditional(ids);
                setIsLoading(false);
                messageBarVM.showError("Apply Failed.");
            }
        }).catch(() => {
            setIsLoading(false);
            messageBarVM.showError('Delete Failed.');
        });
    }, [additionalState.tableData, additionalState.editingEntity, counterCustomerChargeVM, messageBarVM, counterCustomerChargeState.searchCriteria, operatingUnit]);

    const memoBtns = useMemo(() => {

        const hdrBtns = [];
        hdrBtns.push({
            id: 'onEditButton',
            icon: 'Icon-pen',
            title: 'Edit'
        })
        hdrBtns.push({
            id: 'onDeleteButton',
            icon: 'Icon-trash',
            title: 'Delete'
        })

        return hdrBtns
    }, [])

    const template = useMemo(() => {
        return (
            <>
                <div style={{ width: "100%", display: "flex", justifyContent: "flex-end" }}>
                    <div style={{ marginRight: "5px", display: "flex" }}>
                        <HPHButton disabled={false} label={WorkspaceConstant.Common.BUTTON_APPLY} size={'Small'} theme={'Secondary'} onClick={handApply} />
                    </div>
                </div>
            </>
        )
    }, [handApply])

    const memoCols = useMemo(() => {
        if (operatingUnit === 'AQCT' || operatingUnit === 'RSCT') {
            return INITIAL_ADDITIONAL_CHARGE_COL_DEF_AQCT;
        } else if (operatingUnit === 'OICT' || operatingUnit === 'HPJZ') {
            return INITIAL_ADDITIONAL_CHARGE_COL_DEF_OICT;
        } else {
            return INITIAL_ADDITIONAL_CHARGE_COL_DEF;
        }
    }, [operatingUnit])

    const memoAdditionalChargeDetailTable = useMemo(() => {

        return (
            <NbisTable
                id='additional-charge-table'
                isNewColumnSetting={true}
                columns={memoCols.slice()}
                data={transferRowData(additionalState.tableData ?? [])}
                headerActionButtons={memoBtns}
                onEditButton={handEdit}
                onDeleteButton={handleDeleteClick}
                // headerLabel={<OverflowMenuButton disabled={false} icon="Icon-copy" toolTipText="Copy" navigationList={copyItemList} className={"title-overflowMenu-forStdProposalCopy"} />}
                showPaginator={false}
                editable={false}
                showAddIcon={true}
                onAddClick={handleAdd}
                showDeleteButton={false}
                showUploadIcon={false}
                showReloadIcon={false}
                isScrollHighlighted={true}
                selectionMode={false}
                rowSelection={"multiple"}
                isRowHighligted={true}
                onRowDoubleClick={(e: any, entity: CounterCustomerChargeEntity) => handleRowDoubleClick(entity)}
                handleSelectionChanged={handleSelectionChange}
                gridHeight="customHeight"
                customHeight={(operatingUnit === 'OICT' || operatingUnit === 'HPJZ') ? "calc(100vh - 525px)" : "calc(100vh - 408px)"}
                ref={gridRef}
                headerLabel={template}
            />
        );
    }, [operatingUnit, memoCols, additionalState.tableData, memoBtns, handEdit, handleDeleteClick, handleAdd, handleSelectionChange, template, handleRowDoubleClick])

    return <><div className="main-comp-wrapper">
        <TableWrapper>
            {(isLoading) && <Loader Indicator="Spinner" size="Medium" />}
            <div className={`main-comp-wrapper${additionalState.isShowEditPanel ? '' : ' im-hide-side-form-draggable'}`}>
                <SliderPanel
                    isOpen={true}
                    draggable={true}
                    leftSectionWidth={!additionalState.isShowEditPanel ? "100%" : "75%"}
                    rightSectionWidth={!additionalState.isShowEditPanel ? "0%" : "25%"}
                    leftChildren={memoAdditionalChargeDetailTable}
                    rightChildren={<AdditionalChargeEditPanel />}
                />
            </div>
        </TableWrapper>

        <StyledAction className="tm-animated-wrapper">
            <ConfirmDeleteModal headerText={WorkspaceConstant.Common.BUTTON_DELETE + " Additional Charge"}
                contentText={`${MessageConstant.common.DELETE_ALERT_TITLE}\n${MessageConstant.common.DELETE_ALERT_MESSAGE}`}
                visible={additionalState.isShowDeleteModal}
                onCancelClick={handleCancel}
                onDeleteClick={handleDelete}
            />
        </StyledAction>
    </div></>;
}

export default memo(AdditionalChargeTablePanel);
